/**
 * `react-international-phone` always emits the phone in E.164 format including the
 * dial code (e.g. `+12025550123`). Before the user types any national number the
 * value is just the dial code (`+1`); treat that as empty so a bare `+1` is never
 * stored or sent to the backend, and so the freshly-switched field stays error-free.
 */
export const normalizePhoneValue = (phone: string, dialCode: string): string => {
  const phoneDigits = phone.replace(/\D/g, '');
  const dialDigits = dialCode.replace(/\D/g, '');
  return phoneDigits.length > dialDigits.length ? phone : '';
};
